import React, {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
// import {useDispatch} from 'react-redux';
// import {Gatekeeper} from 'gatekeeper-client-sdk';
// import {loadUser, logoutUser} from '@store/reducers/auth';
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';

import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';

import Log from '@pages/log/Log';

import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';

// import ReportPostByWebAnalysis from '@pages/report/ReportPostByWebAnalysis';
// import ReportPostQuantityCreateBy from '@app/pages/report/ReportPostQuantityCreateBy';
// import ReportPostCreateBy from '@app/pages/report/ReportPostCreateBy';
// import ReportViewDetail from '@app/pages/report/reportViewDetail/ReportViewDetail';
// import ReportPostPublishTimeAndDataType from '@pages/report/ReportPostPublishTimeAndDataType';
// import RepostAdvertising from '@pages/report/RepostAdvertising';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';

import {URI_INTERNAL} from '../../utils/pathLocations';
import DonVi from '@app/pages/donVi/DonVi';
import DonViAdd from '@app/pages/donVi/DonViAdd';
import DonViEdit from '@app/pages/donVi/DonViEdit';

import Disease from '@app/pages/disease/Disease';
import DiseaseAdd from '@app/pages/disease/DiseaseAdd';
import DiseaseEdit from '@app/pages/disease/DiseaseEdit';
import DiseaseAddPatient from '@app/pages/disease/DiseaseAddPatient';

import Exercise from '@app/pages/exercise/Exercise';
import ExerciseAdd from '@app/pages/exercise/ExerciseAdd';
import ExerciseEdit from '@app/pages/exercise/ExerciseEdit';
import SelectExercise from '@app/pages/patient/SelectExercise';
import SelectDoctor from '@app/pages/patient/SelectDoctor';
import PatientPractice from '@app/pages/patient/PatientPractice';
import DoctorObserve from '@app/pages/doctor/DoctorObserve';
import DoctorObserveDetail from '@app/pages/doctor/DoctorObserveDetail';
import {getInfomationAccountFromToken} from '@app/utils/helper';
import {role} from '@app/utils/define';
import AccountPatient from '@app/pages/accountPatient/AccountPatient';
import ExerciseDetail from '@app/pages/exercise/ExerciseDetail';
import PatientExercise from '@app/pages/patient/PatientExercise';

// import PageLoading from '../../components/page-loading/PageLoading';

const Main = () => {
    const account = getInfomationAccountFromToken();

    let accountRolePatient = false;
    let accountRoleDoctor = false;

    if (account && account.role) {
        const userRole = account.role.split(', ');
        accountRolePatient = userRole.includes(role.Patient);
        accountRoleDoctor = userRole.includes(role.Doctor);
    }
    // const [appLoadingState, updateAppLoading] = useState(false);
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     updateAppLoading(true);
    //     const fetchProfile = async () => {
    //         try {
    //             const response = await Gatekeeper.getProfile();
    //             dispatch(loadUser(response));
    //             updateAppLoading(false);
    //         } catch (error) {
    //             dispatch(logoutUser());
    //             updateAppLoading(false);
    //         }
    //     };
    //     fetchProfile();
    //     return () => {};
    // }, []);

    // useEffect(() => {

    // }, []);

    // const token = localStorage.getItem(TOKEN_KEY);

    // // const [permitted, setPermitted] = useState()

    // if (token) {
    // }

    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');

    document.body.className += ' sidebar-mini';

    const toggleMenuSidebar = () => {
        document.body.classList.add('sidebar-collapse');
        document.body.classList.remove('sidebar-open');
    };

    const template = (
        <>
            <Header />

            <MenuSidebar />

            <div className="content-wrapper">
                <div className="pt-3" />
                <section className="content">
                    <Switch>
                        <Route exact path="/profile" component={Profile} />
                        {accountRolePatient ? (
                            <Route exact path="/" component={PatientExercise} />
                        ) : accountRoleDoctor ? (
                            <Route exact path="/" component={Dashboard} />
                        ) : (
                            <Route exact path="/" component={Dashboard} />
                        )}
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH}
                            component={Account}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH_ADD}
                            component={AccountAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH_EDIT}
                            component={AccountEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_PATH}
                            component={EmailConfig}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_CREATE_PATH}
                            component={EmailConfigAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_EDIT_PATH}
                            component={EmailConfigEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.LOGIN_HISTORY_PATH}
                            component={LoginHistory}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.STATISTIC_HISTORY_PATH}
                            component={StatisticLoginHistory}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.LOG_PATH}
                            component={Log}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.DONVI_PATH}
                            component={DonVi}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DONVI_CREATE_PATH}
                            component={DonViAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DONVI_EDIT_PATH}
                            component={DonViEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.DISEASE_PATH}
                            component={Disease}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DISEASE_CREATE_PATH}
                            component={DiseaseAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DISEASE_EDIT_PATH}
                            component={DiseaseEdit}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.DISEASE_ADD_PATIENT_PATH}
                            component={DiseaseAddPatient}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.EXERCISE_CREATE_PATH}
                            component={ExerciseAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EXERCISE_EDIT_PATH}
                            component={ExerciseEdit}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EXERCISE_DETAIL_PATH}
                            component={ExerciseDetail}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EXERCISE_PATH}
                            component={Exercise}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.PATIENTEXERCISE_PATH}
                            component={DoctorObserve}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.PATIENTEXERCISE_DETAIL_PATH}
                            component={DoctorObserveDetail}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.PATIENTEXERCISE_CHOSEN_PATH}
                            component={PatientExercise}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.PATIENTPRACTICE_PATH}
                            component={PatientPractice}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.SELECTDOCTOR_PATH}
                            component={SelectDoctor}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.SELECTEXERCISE_PATH}
                            component={SelectExercise}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNTPATIENT_PATH}
                            component={AccountPatient}
                        />
                    </Switch>
                </section>
            </div>
            <Footer />
            <div
                id="sidebar-overlay"
                role="presentation"
                onClick={toggleMenuSidebar}
                onKeyDown={() => {}}
            />
        </>
    );

    // if (appLoadingState) {
    //     template = <PageLoading />;
    // } else {
    //     template = (
    //         <>
    //             <Header toggleMenuSidebar={toggleMenuSidebar} />

    //             <MenuSidebar />

    //             <div className="content-wrapper">
    //                 <div className="pt-3" />
    //                 <section className="content">
    //                     <Switch>
    //                         <Route exact path="/profile" component={Profile} />
    //                         <Route exact path="/" component={Dashboard} />
    //                     </Switch>
    //                 </section>
    //             </div>
    //             <Footer />
    //             <div
    //                 id="sidebar-overlay"
    //                 role="presentation"
    //                 onClick={toggleMenuSidebar}
    //                 onKeyDown={() => {}}
    //             />
    //         </>
    //     );
    // }

    return <div className="wrapper">{template}</div>;
};

export default Main;
